import { type FC } from 'react'
import { useIntl } from 'react-intl'
import isEmail from 'validator/lib/isEmail'

import { DirectContactFormTextField } from './DirectContactFormTextField'

export const DirectContactFormCustomerFields: FC<{
  clearErrorOnClick?: boolean
  isCustomerDataComplete: boolean
}> = ({ clearErrorOnClick, isCustomerDataComplete }) => {
  const intl = useIntl()

  if (isCustomerDataComplete) {
    return null
  }

  const invalidEmailMessage = intl.formatMessage({
    id: 'error.email.invalid',
  })

  const requiredMessage = intl.formatMessage({
    id: 'form.error.input.missing',
  })

  return (
    <>
      <div className="grid gap-4 tablet:grid-cols-2">
        <DirectContactFormTextField
          autoComplete="given-name"
          clearErrorOnClick={clearErrorOnClick}
          data-qa-id="message-form-emailForm-firstName"
          label={intl.formatMessage({ id: 'general.label.firstName' })}
          name="firstName"
          required
          rules={{ required: requiredMessage }}
        />
        <DirectContactFormTextField
          autoComplete="family-name"
          clearErrorOnClick={clearErrorOnClick}
          data-qa-id="message-form-emailForm-lastName"
          label={intl.formatMessage({ id: 'general.label.surname' })}
          name="lastName"
          required
          rules={{ required: requiredMessage }}
        />
      </div>
      <DirectContactFormTextField
        autoComplete="email"
        clearErrorOnClick={clearErrorOnClick}
        data-qa-id="message-form-emailForm-email"
        label={intl.formatMessage({ id: 'general.label.email' })}
        name="email"
        required
        rules={{
          required: requiredMessage,
          validate: (value) => isEmail(value) || invalidEmailMessage,
        }}
        type="email"
      />
    </>
  )
}
